import { useEffect, useState } from 'react';
import { TextField, Box, Chip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';

interface TagsInputProps {
  onChange: (tags: string[]) => void;
  initialTags?: string[]
}

export const TagsInput: React.FC<TagsInputProps> = ({ onChange, initialTags }) => {
  const [tags, setTags] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const { t } = useTranslation();

  const handleAutocompleteChange = (event: React.ChangeEvent<{}>, newValue: string[]) => {
    const normalizedTags = newValue
      .map(tag => tag.trim())
      .filter((tag, index, allTags) => tag !== '' && allTags.indexOf(tag) === index)
      .slice(0, 2);

    setTags(normalizedTags);
    onChange(normalizedTags);
  };
  
  const commitInputValue = () => {
    const trimmedInputValue = inputValue.trim();
    if (trimmedInputValue === '' || tags.length >= 2 || tags.includes(trimmedInputValue)) return;

    const newTags = [...tags, trimmedInputValue];
    setTags(newTags);
    onChange(newTags);
    setInputValue('');
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if(event.key === 'Enter') {
      commitInputValue();
    }
  }

  const handleBlur = () => {
    commitInputValue();
  }

  useEffect(() => {
    if (!!initialTags && initialTags.length > 0) {
      setTags(initialTags);
    } 
  }, [initialTags]);

  return (
    <Box>
      <Autocomplete
        multiple
        freeSolo
        value={tags}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={handleAutocompleteChange}
        options={[]}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={t('inviteUserDialog.tags')}
            placeholder={t('inviteUserDialog.addTag')}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
      />
    </Box>
  );
};